import moment from 'moment';
import 'moment/dist/locale/fr.js';

moment.locale('fr');

class Commons {
  static time(time, dateFormat = 'DD MMMM YYYY') {
    if (/^\d+$/.test(time)) time = parseInt(`${time}`);
    return moment(new Date(time)).format(dateFormat);
  }

  static formatNumber(
    value,
    { locale = 'fr-FR', decimals = 0, compact = false, suffix = '' } = {}
  ) {
    if (value == null || isNaN(value)) return '—';

    const formatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      notation: compact ? 'compact' : 'standard',
      compactDisplay: 'short'
    });

    return formatter.format(value) + suffix;
  }

  static copyToClipboard(text, onSuccess = () => {}, onFailed = (err) => {}) {
    try {
      const type = 'text/plain';
      const blob = new Blob([text], { type });
      const data = [new ClipboardItem({ [type]: blob })];
      navigator.clipboard.write(data);
      onSuccess && onSuccess();
    } catch (error) {
      console.log('🚀 ~ Commons ~ copyToClipboard ~ error:', error);
      onFailed && onFailed(error);
    }
  }

  static setThemeColor(color = '#ffffff') {
    try {
      const themeColorMetaTag = document.querySelector('[name="theme-color"]');
      themeColorMetaTag.setAttribute('content', color);
      if (themeColorMetaTag.getAttribute('content') !== color)
        Commons.setThemeColor(color);
    } catch (error) {
      console.log('🚀 ~ Commons ~ setThemeColor ~ error:', error);
    }
  }
  
  static generateUUID() {
    const buf = new Uint8Array(16);
    crypto.getRandomValues(buf);

    // Version 4
    buf[6] = (buf[6] & 0x0f) | 0x40;
    buf[8] = (buf[8] & 0x3f) | 0x80;

    const hex = [...buf].map((v) => v.toString(16).padStart(2, '0')).join('');

    return (
      hex.slice(0, 8) +
      '-' +
      hex.slice(8, 12) +
      '-' +
      hex.slice(12, 16) +
      '-' +
      hex.slice(16, 20) +
      '-' +
      hex.slice(20)
    );
  }
}

export default Commons;
